import { actionTypes } from '../actions/gestor.action';
const initialState = {
    gestores: {
        data: []
    },
    chart: {
        period: {
            period_chart: [],
            today: {}, 
            campaigns: [],
            stats: {}
        },
        hour: {
            best_hour: {},
            best_window: {},
            hourly_chart: [],
            campaigns: [],
        },
        gestor: {}
    },
    gestor: {},
    error: {},
    success: false
}

const GestorReducer = (state = initialState, { type, payload, isLoadMore }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.gestores.data = state.gestores.data.concat(payload.gestores.data)
        }

        return { ...state, ...payload }

    case actionTypes.CHART:
        return {
            ...state,
            chart: {
                gestor: payload?.gestor,
                period: {
                    ...state.chart.period,
                    ...payload.period
                },
                hour: {
                    ...state.chart.hour,
                    ...payload.hour
                }
            }
        }

    case actionTypes.UPDATE:
        let index = state.gestores.data.findIndex(item => item.id === payload.id)
        state.gestores.data[index] = payload

        return {
            ...state,
            gestores: {
                ...state.gestores,
                data: [
                    ...[(index < 0) && payload],
                    ...state.gestores.data
                ]
            }
        }

    case actionTypes.CHANGE_GESTOR:
        return {
            ...state,
            gestor: {
                ...state.gestor,
                ...payload
            }
        }

    case actionTypes.DESTROY:
        return {
            ...state,
            gestores: {
                ...state.gestores,
                data: state.gestores.data.filter(item => item.id !== payload)
            }

        }

    case actionTypes.CHANGE:
        return {
            ...state,
            gestor: (payload === 'clear') ? {} : {
                ...state.gestor,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default GestorReducer